import axios from "fetch-api/fetch-api";
import qs from "query-string";
import { getFitmentOptionObj } from "util/vehicle/getFitmentOptionObj";
import { IVehicleSelectionOption } from "../interfaces/garage-apis";

export function getVehicleSelection(params: any) {
  const updatedParams = { ...params };
  const fitmentOptionParams = getFitmentOptionObj(params?.fitmentOptions);
  delete updatedParams?.fitmentOptions;
  const updatedVehicle = { ...updatedParams };
  return axios.get<IVehicleSelectionOption>(`s/get-vehicle-selection-options?${qs.stringify(fitmentOptionParams)}`, {
    params: { ...updatedVehicle },
  });
}
